// extracted by mini-css-extract-plugin
export default {"Banner":"PFSSubscribeBanner_Banner__+qazB","BannerWrapper":"PFSSubscribeBanner_BannerWrapper__rWane","subscribeButton":"PFSSubscribeBanner_subscribeButton__TSvMN"};